export default "__VITE_ASSET__czfBfpKs__"